document.addEventListener("DOMContentLoaded", () => {
  const rankingRoots = document.querySelectorAll(".msi-ranking-root");

  if (!rankingRoots.length) return;

  rankingRoots.forEach((root) => {
    initRankingModule(root);
  });

  function initRankingModule(root) {
    const config = {
      sectionId: root.dataset.sectionId || "",
      publicTsvBase: root.dataset.publicTsvBase || "",
      defaultGid: root.dataset.defaultGid || "",
      indexTsvUrl: root.dataset.indexTsvUrl || "",
      visibleRowsInitial: parseInt(root.dataset.visibleRowsInitial || "24", 10),
      profileBaseUrl: root.dataset.profileBaseUrl || "/pages/perfil-de-competidor",
      rankingQueryParam: root.dataset.rankingQueryParam || "gid",
      playerIdQueryParam: root.dataset.playerIdQueryParam || "id",
      loadingText: root.dataset.loadingText || "Cargando…",
      emptyText: root.dataset.emptyText || "Sin datos en la hoja seleccionada.",
      invalidSourceText: root.dataset.invalidSourceText || "No se pudo leer Google Sheets.",
      permissionsErrorText:
        root.dataset.permissionsErrorText ||
        "Error al cargar Google Sheets. Verifica publicación y permisos.",
      headersErrorText:
        root.dataset.headersErrorText ||
        "Encabezados no encontrados. Esperados: ID/Nombre/Puntos/Ranking.",
      cacheStatusText: root.dataset.cacheStatusText || "Mostrando datos en caché.",
      updatedStatusText: root.dataset.updatedStatusText || "Ranking actualizado.",
      loadMoreLabel: root.dataset.loadMoreLabel || "Ver más jugadores",
      loadLessLabel: root.dataset.loadLessLabel || "Ver menos jugadores",
    };

    const tableBody = root.querySelector("[data-ranking-table-body]");
    const mobileList = root.querySelector("[data-ranking-mobile]");
    const loadMoreWrap = root.querySelector("[data-ranking-loadmore-wrap]");
    const loadMoreBtn = root.querySelector("[data-ranking-loadmore]");
    const searchInput = root.querySelector("[data-ranking-search]");
    const statusNode = root.querySelector("[data-ranking-status]");
    const sheetButtonsWrap = root.querySelector("[data-ranking-sheet-buttons]");

    if (
      !tableBody ||
      !mobileList ||
      !loadMoreWrap ||
      !loadMoreBtn ||
      !searchInput ||
      !statusNode ||
      !sheetButtonsWrap
    ) {
      return;
    }

    const CACHE_TTL_MS = 10 * 60 * 1000;

    let currentPlayers = [];
    let expanded = false;
    let filterText = "";
    let activeGid = "";
    let buttonsLoaded = false;

    init();

    function init() {
      const params = new URL(window.location.href).searchParams;
      const gidFromUrl = params.get(config.rankingQueryParam);
      const qFromUrl = params.get("q");

      activeGid = gidFromUrl || config.defaultGid || "";

      if (qFromUrl) {
        filterText = qFromUrl.trim().toLowerCase();
        searchInput.value = qFromUrl.trim();
        expanded = true;
      }

      setLoadingState();

      ensureButtons()
        .then(() => {
          loadRankingByGid(activeGid);
        })
        .catch(() => {
          loadRankingByGid(activeGid);
        });

      attachEvents();
    }

    function attachEvents() {
      searchInput.addEventListener("input", (event) => {
        filterText = String(event.target.value || "").trim().toLowerCase();
        setQueryParam("q", filterText);
        expanded = true;
        renderRanking(getFilteredPlayers());
      });

      loadMoreBtn.addEventListener("click", () => {
        expanded = !expanded;
        renderRanking(getFilteredPlayers());

        if (!expanded) {
          scrollToRankingTop();
        }
      });
    }

    function setLoadingState() {
      tableBody.innerHTML = `<tr><td colspan="4" style="text-align:center;">${escapeHtml(
        config.loadingText
      )}</td></tr>`;
      mobileList.innerHTML = "";
      loadMoreWrap.style.display = "none";
      setStatus(config.loadingText);
    }

    function setStatus(message) {
      statusNode.textContent = message || "";
    }

    function cacheKey(gid) {
      return `msi:ranking:${config.sectionId}:${gid}`;
    }

    function fetchWithTimeout(url, timeoutMs = 15000) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), timeoutMs);

      return fetch(url, {
        signal: controller.signal,
        cache: "no-store",
      }).finally(() => {
        clearTimeout(timeout);
      });
    }

    function isProbablyHtml(text) {
      return /^\s*<!doctype html|<html/i.test(String(text || ""));
    }

    function parseRows(raw) {
      const cleaned = String(raw || "").replace(/\r/g, "").trim();
      if (!cleaned) return [];

      let rows = cleaned.split("\n").map((line) => line.split("\t"));

      if (rows[0] && rows[0].length === 1 && cleaned.includes(",")) {
        rows = cleaned.split("\n").map((line) => line.split(","));
      }

      return rows;
    }

    function normalizeHeader(value) {
      return String(value || "")
        .normalize("NFKD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim();
    }

    function mapColumns(headers) {
      const normalized = headers.map(normalizeHeader);

      const findAny = (keys) => {
        for (const key of keys) {
          const index = normalized.indexOf(normalizeHeader(key));
          if (index !== -1) return index;
        }
        return -1;
      };

      return {
        id: findAny(["id", "player id", "identificador", "clave"]),
        nombre: findAny(["nombre", "jugador", "nombre jugador", "player", "name"]),
        puntos: findAny(["puntos", "pts", "puntuacion", "puntaje", "score", "total"]),
        ranking: findAny(["ranking", "rank", "posicion", "posición", "pos"]),
      };
    }

    function parseNumberSafe(value) {
      let text = String(value || "").trim();
      text = text.replace(/(?<=\d)[.,](?=\d{3}\b)/g, "");

      if (text.includes(",")) {
        text = text.replace(",", ".");
      }

      const number = parseFloat(text);
      return Number.isFinite(number) ? number : 0;
    }

    function buildTsvUrlFromGid(gid) {
      if (!config.publicTsvBase) return "";

      const url = new URL(config.publicTsvBase);
      url.searchParams.set("output", "tsv");

      if (gid) {
        url.searchParams.set("single", "true");
        url.searchParams.set("gid", gid);
      }

      return url.toString();
    }

    function getGidFromAny(value) {
      const text = String(value || "").trim();
      if (!text) return "";

      try {
        const url = new URL(text);
        const gid = url.searchParams.get("gid");
        if (gid) return gid;
      } catch (error) {
        // No es URL. Se intenta como texto normal.
      }

      const match = text.match(/[?&]gid=([^&#]+)/i);
      if (match) return match[1];

      if (/^\d+$/.test(text)) return text;

      return "";
    }

    function buildProfileUrl(playerId) {
      const url = new URL(config.profileBaseUrl, window.location.origin);
      url.searchParams.set(config.playerIdQueryParam, playerId);
      return `${url.pathname}${url.search}`;
    }

    function setQueryParam(key, value) {
      const url = new URL(window.location.href);

      if (value) {
        url.searchParams.set(key, value);
      } else {
        url.searchParams.delete(key);
      }

      window.history.replaceState({}, "", url.toString());
    }

    function scrollToRankingTop() {
      root.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }

    function showErrorRow(message) {
      tableBody.innerHTML = `<tr><td colspan="4" style="text-align:center;color:#fecaca">${escapeHtml(
        message
      )}</td></tr>`;
      mobileList.innerHTML = "";
      loadMoreWrap.style.display = "none";
    }

    function processRaw(raw) {
      if (!raw || isProbablyHtml(raw)) {
        showErrorRow(config.invalidSourceText);
        setStatus(config.invalidSourceText);
        return;
      }

      const rows = parseRows(raw);

      if (!rows || rows.length <= 1) {
        currentPlayers = [];
        renderRanking([]);
        setStatus(config.emptyText);
        return;
      }

      const headers = rows[0];
      const columns = mapColumns(headers);

      let idxID = columns.id;
      let idxNombre = columns.nombre;
      let idxPuntos = columns.puntos;
      let idxRanking = columns.ranking;

      if ([idxID, idxNombre, idxPuntos, idxRanking].some((value) => value < 0)) {
        if (headers.length >= 4) {
          idxID = idxID >= 0 ? idxID : 0;
          idxNombre = idxNombre >= 0 ? idxNombre : 1;
          idxPuntos = idxPuntos >= 0 ? idxPuntos : 2;
          idxRanking = idxRanking >= 0 ? idxRanking : 3;
        } else {
          showErrorRow(config.headersErrorText);
          setStatus(config.headersErrorText);
          return;
        }
      }

      const players = rows
        .slice(1)
        .map((row) => {
          const id = String(row[idxID] || "").trim();
          const nombre = String(row[idxNombre] || "").trim();
          const puntos = String(row[idxPuntos] || "").trim();
          const puntosNum = parseNumberSafe(puntos);
          const rankingRaw = parseInt(String(row[idxRanking] || "").trim(), 10);

          return {
            id,
            nombre,
            puntos,
            puntosNum,
            ranking: Number.isFinite(rankingRaw) ? rankingRaw : Infinity,
          };
        })
        .filter((player) => player.id && player.nombre);

      players.sort((a, b) => {
        const rankA = Number.isFinite(a.ranking) ? a.ranking : 999999;
        const rankB = Number.isFinite(b.ranking) ? b.ranking : 999999;

        if (rankA !== rankB) return rankA - rankB;

        return b.puntosNum - a.puntosNum;
      });

      currentPlayers = players;
      renderRanking(getFilteredPlayers());
      setStatus(config.updatedStatusText);
    }

    async function loadRankingByGid(gid) {
      activeGid = gid || config.defaultGid || "";

      highlightActiveButton(activeGid);
      setQueryParam(config.rankingQueryParam, activeGid);
      setLoadingState();

      const tsvUrl = buildTsvUrlFromGid(activeGid);

      if (!tsvUrl) {
        showErrorRow(config.invalidSourceText);
        setStatus(config.invalidSourceText);
        return;
      }

      const cached = getCache(activeGid);

      if (cached && isCacheFresh(cached)) {
        try {
          processRaw(cached.raw);
        } catch (error) {
          // Si falla caché, intenta red.
        }

        fetchWithTimeout(tsvUrl, 15000)
          .then((response) => {
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            return response.text();
          })
          .then((raw) => {
            setCache(activeGid, raw);
          })
          .catch(() => {
            // Fallo silencioso en actualización secundaria.
          });

        return;
      }

      try {
        const response = await fetchWithTimeout(tsvUrl, 15000);

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const raw = await response.text();
        setCache(activeGid, raw);
        processRaw(raw);
      } catch (error) {
        if (cached && cached.raw) {
          try {
            processRaw(cached.raw);
            setStatus(config.cacheStatusText);
            return;
          } catch (cacheError) {
            // Continúa al error final.
          }
        }

        showErrorRow(config.permissionsErrorText);
        setStatus(config.permissionsErrorText);
      }
    }

    function getCache(gid) {
      try {
        const raw = window.localStorage.getItem(cacheKey(gid));
        return raw ? JSON.parse(raw) : null;
      } catch (error) {
        return null;
      }
    }

    function setCache(gid, raw) {
      try {
        window.localStorage.setItem(
          cacheKey(gid),
          JSON.stringify({
            time: Date.now(),
            raw,
          })
        );
      } catch (error) {
        // Sin localStorage, la sección sigue funcionando.
      }
    }

    function isCacheFresh(cache) {
      if (!cache || !cache.time) return false;
      return Date.now() - cache.time < CACHE_TTL_MS;
    }

    function getFilteredPlayers() {
      let players = currentPlayers.slice();

      if (filterText) {
        players = players.filter((player) =>
          player.nombre.toLowerCase().includes(filterText)
        );
      }

      return players;
    }

    function renderRanking(players) {
      renderDesktopTable(players);
      renderMobileCards(players);
      updateLoadMore(players);
    }

    function getRankDisplay(player) {
      if (!Number.isFinite(player.ranking)) return "-";
      if (player.ranking === 1) return "🥇 1";
      if (player.ranking === 2) return "🥈 2";
      if (player.ranking === 3) return "🥉 3";
      return String(player.ranking);
    }

    function renderDesktopTable(players) {
      tableBody.innerHTML = "";

      if (!players.length) {
        tableBody.innerHTML = `<tr><td colspan="4" style="text-align:center;">${escapeHtml(
          config.emptyText
        )}</td></tr>`;
        return;
      }

      const fragment = document.createDocumentFragment();
      const visibleLimit = expanded
        ? players.length
        : Math.min(players.length, config.visibleRowsInitial);

      players.forEach((player, index) => {
        const visible = index < visibleLimit;
        const profileUrl = buildProfileUrl(player.id);
        const profileLabel = `Ver perfil de ${player.nombre}`;

        const row = document.createElement("tr");
        row.className = visible ? "revelado" : "oculto";
        row.dataset.profileUrl = profileUrl;

        if (Number.isFinite(player.ranking) && player.ranking <= 3) {
          row.classList.add(`ranking-top-${player.ranking}`);
        }

        row.addEventListener("click", (event) => {
          if (event.target.closest("a")) return;
          window.location.href = profileUrl;
        });

        const rankCell = document.createElement("td");
        rankCell.textContent = getRankDisplay(player);

        const nameCell = document.createElement("td");
        nameCell.textContent = player.nombre;

        const pointsCell = document.createElement("td");
        pointsCell.textContent = player.puntos;

        const profileCell = document.createElement("td");
        profileCell.className = "profile-cell";

        const profileLink = document.createElement("a");
        profileLink.href = profileUrl;
        profileLink.className = "profile-link";
        profileLink.setAttribute("aria-label", profileLabel);
        profileLink.setAttribute("title", profileLabel);

        profileLink.innerHTML = `
          <i class="fas fa-user" aria-hidden="true"></i>
          <span class="profile-link-label">Perfil</span>
        `;

        profileCell.appendChild(profileLink);
        row.append(rankCell, nameCell, pointsCell, profileCell);
        fragment.appendChild(row);
      });

      tableBody.appendChild(fragment);
    }

    function renderMobileCards(players) {
      mobileList.innerHTML = "";

      if (!players.length) return;

      const visibleLimit = expanded
        ? players.length
        : Math.min(players.length, config.visibleRowsInitial);

      players.slice(0, visibleLimit).forEach((player) => {
        const profileUrl = buildProfileUrl(player.id);
        const profileLabel = `Ver perfil de ${player.nombre}`;

        const card = document.createElement("a");
        card.className = "player-card";
        card.href = profileUrl;
        card.setAttribute("aria-label", profileLabel);
        card.setAttribute("title", profileLabel);

        if (Number.isFinite(player.ranking) && player.ranking <= 3) {
          card.classList.add(`player-card-top-${player.ranking}`);
        }

        card.innerHTML = `
          <div class="player-card-main">
            <div class="player-rank">${escapeHtml(getRankDisplay(player))}</div>
            <div class="player-info">
              <div class="player-name">${escapeHtml(player.nombre)}</div>
              <div class="player-meta-row">
                <span class="player-points-badge">${escapeHtml(player.puntos)} pts temporada</span>
                <span class="player-meta-hint">Ver perfil de competidor</span>
              </div>
            </div>
          </div>
          <div class="player-chevron">
            <i class="fa-solid fa-chevron-right" aria-hidden="true"></i>
          </div>
        `;

        mobileList.appendChild(card);
      });
    }

    function updateLoadMore(players) {
      const hasMore = players.length > config.visibleRowsInitial;

      loadMoreWrap.style.display = hasMore ? "block" : "none";
      loadMoreBtn.setAttribute("aria-expanded", expanded ? "true" : "false");
      loadMoreBtn.textContent = expanded
        ? config.loadLessLabel
        : config.loadMoreLabel;
    }

    async function ensureButtons() {
      if (buttonsLoaded) return;

      try {
        const buttons = await fetchIndexButtons();

        if (buttons.length) {
          renderButtons(buttons);
          buttonsLoaded = true;
          return;
        }
      } catch (error) {
        // Usa fallback.
      }

      const fallbackButtons = [];

      if (config.defaultGid) {
        fallbackButtons.push({
          gid: config.defaultGid,
          label: "🏆 Temporada actual",
          estado: "Activa",
          orden: 1,
        });
      }

      renderButtons(fallbackButtons);
      buttonsLoaded = true;
    }

    async function fetchIndexButtons() {
      if (!config.indexTsvUrl) return [];

      const response = await fetchWithTimeout(config.indexTsvUrl, 15000);

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const raw = await response.text();

      if (!raw || isProbablyHtml(raw)) {
        throw new Error("Invalid index source");
      }

      const rows = parseRows(raw);

      if (!rows || rows.length <= 1) {
        throw new Error("Empty index");
      }

      const headers = rows[0].map(normalizeHeader);

      const nombreTemporadaIndex = findHeaderIndex(headers, [
        "nombre temporada",
        "temporada",
        "titulo",
        "título",
        "nombre",
        "label",
      ]);

      const gidIndex = findHeaderIndex(headers, [
        "gid",
        "sheet gid",
        "id hoja",
      ]);

      const destinoIndex = findHeaderIndex(headers, [
        "destino",
        "url",
        "link",
        "enlace",
      ]);

      const estadoIndex = findHeaderIndex(headers, [
        "estado",
        "status",
      ]);

      const ordenIndex = findHeaderIndex(headers, [
        "orden",
        "order",
        "posicion",
        "posición",
      ]);

      if (nombreTemporadaIndex === -1 || (gidIndex === -1 && destinoIndex === -1)) {
        throw new Error("Missing expected index columns");
      }

      return rows
        .slice(1)
        .map((row) => {
          const label = String(row[nombreTemporadaIndex] || "").trim();
          const gidSource =
            gidIndex !== -1
              ? String(row[gidIndex] || "").trim()
              : String(row[destinoIndex] || "").trim();

          const gid = getGidFromAny(gidSource);

          if (!gid) return null;

          const estado =
            estadoIndex !== -1
              ? String(row[estadoIndex] || "").trim()
              : "";

          const orden =
            ordenIndex !== -1
              ? parseInt(String(row[ordenIndex] || "").trim(), 10)
              : 999;

          return {
            gid,
            label: formatSeasonLabel(label || `Temporada ${gid}`, estado),
            estado,
            orden: Number.isFinite(orden) ? orden : 999,
          };
        })
        .filter(Boolean)
        .sort((a, b) => {
          if (a.orden !== b.orden) return a.orden - b.orden;
          return a.label.localeCompare(b.label);
        });
    }

    function findHeaderIndex(headers, candidates) {
      for (const candidate of candidates) {
        const normalizedCandidate = normalizeHeader(candidate);
        const index = headers.indexOf(normalizedCandidate);

        if (index !== -1) return index;
      }

      return -1;
    }

    function formatSeasonLabel(label, estado) {
      const cleanLabel = String(label || "").trim();
      const cleanEstado = normalizeHeader(estado);

      if (cleanEstado === "activa" || cleanEstado === "activo") {
        return `🏆 ${cleanLabel}`;
      }

      if (cleanEstado === "historico" || cleanEstado === "histórico") {
        return `👑 ${cleanLabel}`;
      }

      if (cleanEstado === "especial") {
        return `✨ ${cleanLabel}`;
      }

      if (cleanEstado === "cerrada" || cleanEstado === "cerrado") {
        return `⚔️ ${cleanLabel}`;
      }

      return cleanLabel;
    }

    function renderButtons(buttons) {
      sheetButtonsWrap.innerHTML = "";

      buttons.forEach((buttonData) => {
        const button = document.createElement("button");
        button.type = "button";
        button.className = "mf-btn";
        button.dataset.gid = buttonData.gid;
        button.textContent = buttonData.label;

        if (buttonData.estado) {
          button.dataset.estado = buttonData.estado;
        }

        button.addEventListener("click", () => {
          expanded = false;
          loadRankingByGid(buttonData.gid);
          scrollToRankingTop();
        });

        sheetButtonsWrap.appendChild(button);
      });

      highlightActiveButton(activeGid);
    }

    function highlightActiveButton(gid) {
      const buttons = sheetButtonsWrap.querySelectorAll("button.mf-btn");

      buttons.forEach((button) => {
        const isActive = button.dataset.gid === gid;
        button.classList.toggle("is-active", isActive);
        button.setAttribute("aria-pressed", isActive ? "true" : "false");
      });
    }

    function escapeHtml(value) {
      return String(value || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    }
  }
});